import axios from 'axios';
export const checkRequest = async (id) => {
  return await axios({
    url: `/finance/check-request/${id}`
  }).then((res) => res.data);
};

export const resolveRequest = async ({ id }) => {
  return await axios({
    url: `/finance/resolve-request/${id}`,
    method: 'PUT'
  }).then((res) => res.data);
};
